export default __webpack_public_path__ + "static/media/vk-full.dd973be8.svg";